export default __webpack_public_path__ + "static/media/LOBO-ESTEPARIO.6aa3bf31.png";